import { RULESET as d, KEYFRAMES as h, DECLARATION as E, WEBKIT as u, MOZ as f, MS as g } from "./index.es255.js";
import { combine as v, replace as n, sizeof as R, match as b, assign as l, filter as m } from "./index.es345.js";
import { copy as p, lift as e } from "./index.es346.js";
import { serialize as k } from "./index.es257.js";
import { prefix as x } from "./index.es347.js";
function S(r) {
  var a = R(r);
  return function(t, o, s, w) {
    for (var c = "", i = 0; i < a; i++)
      c += r[i](t, o, s, w) || "";
    return c;
  };
}
function T(r) {
  return function(a) {
    a.root || (a = a.return) && r(a);
  };
}
function B(r, a, t, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case E:
        r.return = x(r.value, r.length, t);
        return;
      case h:
        return k([p(r, { value: n(r.value, "@", "@" + u) })], o);
      case d:
        if (r.length)
          return v(t = r.props, function(s) {
            switch (b(s, o = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                e(p(r, { props: [n(s, /:(read-\w+)/, ":" + f + "$1")] })), e(p(r, { props: [s] })), l(r, { props: m(t, o) });
                break;
              // :placeholder
              case "::placeholder":
                e(p(r, { props: [n(s, /:(plac\w+)/, ":" + u + "input-$1")] })), e(p(r, { props: [n(s, /:(plac\w+)/, ":" + f + "$1")] })), e(p(r, { props: [n(s, /:(plac\w+)/, g + "input-$1")] })), e(p(r, { props: [s] })), l(r, { props: m(t, o) });
                break;
            }
            return "";
          });
    }
}
export {
  S as middleware,
  B as prefixer,
  T as rulesheet
};
//# sourceMappingURL=index.es256.js.map
